import '.ei{padding:16px 20px;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.ej{width:fit-content;}.ssr-plugin'
import '.ek{backdrop-filter:blur(36px);}.ssr-plugin'
import '.el{-webkit-backdrop-filter:blur(36px);}.ssr-plugin'
import '.dj{cursor:pointer;}.ssr-plugin'
import '.dm{transition:all 200ms ease;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cb{gap:16px;}.ssr-plugin'
import '.au{font-size:14px;}.ssr-plugin'
import '.at{opacity:0.5;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../../utils/colors.js'
import { transparentColor } from '../../utils/transparentcolor.js'
import { Icon } from '../../assets/icons/index.js'
import { MOBILE } from '../../utils/breakpoints.js'

export const LinkNotes = () => {
  return (
    <styled.div>
      <LinkNote
        title="Eurovision.com"
        description="Official website of the Eurovision Song Contest"
        link="https://www.eurovision.com"
      />
      <LinkNote
        title="EBU.ch"
        description="European Broadcasting Union"
        link="https://www.ebu.ch"
      />
    </styled.div>
  )
}

const LinkNote = ({ link, title, description }) => {
  return (
    <styled.div className="ei cx bn ej ek el dj dm"
      style={{
        border: `1px solid ${colors.border}`,
        '&:hover': {
          backgroundColor: transparentColor(colors.white, 0.2),
          scale: 0.98,
        },
        [MOBILE]: {
          width: 'auto',
        },
      }}
      onClick={() => window.open(link, '_blank')}
    >
      <div className="e w cb"
      >
        <Icon type="globeIcon" color={colors.white} style={{ opacity: 0.5 }} />
        <styled.div>
          <styled.a
          // href={link}
          // target="_blank"
          >
            {title}
          </styled.a>
          <p className="au at">
            {description}
          </p>
        </styled.div>
      </div>
    </styled.div>
  )
}
